import "./Services.scss";
import { FormattedMessage } from "react-intl";
import Divider from "component/divider/divider";
import useSwr from "swr";
import { END_POINTS } from "constants/APIConstant";
import ServiceCard from "./components/service-card";
import CardTool from "component/shared/cardTool/CardTool";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import MainButton from "component/shared/mainButton/MainButton";

function Services() {
  const servicesData = useSwr({ url: END_POINTS.SERVICES_HOME });

  const RenderServices = () => {
    const slicedItems =
      servicesData.error ||
      servicesData.isLoading ||
      servicesData.data === undefined ||
      servicesData?.data?.data?.length <= 0
        ? []
        : servicesData?.data?.data?.slice(0, 10);

    return Object.keys(slicedItems).length > 0 ? (
      slicedItems.map(
        (
          {
            title,
            image,
            isInternal,
            link,
            shortDescription,
            serviceAndToolTranslation,
            isSystem,
            id
          },
          index
        ) => (
          <div key={index} className=" col-lg-4">
            <ServiceCard
              title={title}
              description={shortDescription}
              link={link}
              serviceAndToolTranslation={serviceAndToolTranslation}
              isInternal={isInternal}
              isSystem={isSystem} 
              id={id} 
            />
          </div>
        )
      )
    ) : (
      <DataNotFound />
    );
  };

  return (
    <div className="services">
      <div className="container">
        <Divider />
        <div className="section-title">
          <FormattedMessage id="services" />
        </div>
        <div className="row">
          <RenderServices />
        </div>
        <div className="row-r mt-5">
          <MainButton link={"servicestools"} text={"all-service"} />
        </div>
      </div>
    </div>
  );
}

export default Services;
